import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { DollarSign, TrendingUp, Calendar } from 'lucide-react';
import './PricingTab.css';

const PricingTab = ({ hotelId, token }) => {
  const [pricing, setPricing] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (hotelId && token) {
      fetchPricing();
    }
  }, [hotelId, token]);

  const fetchPricing = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/pricing/rooms`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setPricing(response.data);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching pricing:', err);
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="tab-loading"><div className="loading-spinner"></div><p>Loading pricing data...</p></div>;
  }

  return (
    <div className="pricing-tab">
      <div className="tab-header">
        <h2><DollarSign size={24} /> Pricing Management</h2>
      </div>

      <div className="pricing-table-container">
        <table className="pricing-table">
          <thead>
            <tr>
              <th>Room</th>
              <th>Type</th>
              <th>Base Price</th>
              <th>Current Price</th>
              <th>Season</th>
              <th>Effective From</th>
            </tr>
          </thead>
          <tbody>
            {pricing.map((room, idx) => (
              <tr key={idx}>
                <td><strong>{room.room_number}</strong></td>
                <td>{room.room_type}</td>
                <td>${room.base_price}</td>
                <td><strong>${room.current_price || room.base_price}</strong></td>
                <td>{room.season || 'Standard'}</td>
                <td>{room.effective_from ? new Date(room.effective_from).toLocaleDateString() : '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {pricing.length === 0 && <div className="empty-state"><DollarSign size={48} /><h3>No Pricing Data</h3><p>Configure room pricing to get started</p></div>}
    </div>
  );
};

export default PricingTab;
